import React from 'react';
import { Section, SettingsSectionBox, SettingsSectionLabel } from '@views/Settings/components';
import styles from './Zapier.module.scss';
import { useAuthContext } from '@repo/hooks';
import { CopyBtn } from '../CardDav';

export default function Zapier() {
  const { user } = useAuthContext();

  return (
    <Section>
      <SettingsSectionLabel>Zapier</SettingsSectionLabel>
      <SettingsSectionBox>
        <div className={styles.row}>
          {user.zapier_key}
          <CopyBtn value={user.zapier_key} label="key" />
        </div>
      </SettingsSectionBox>
      <div className={styles.infoText}>
        Zapier lets you create automations using Clay.{' '}
        <a href="https://zapier.com/apps/clay-claydotearth/integrations" target="_blank">
          Click here to add Clay to your Zapier account
        </a>{' '}
        using the key shown above.
      </div>
      <div className={styles.infoText}>
        Once you've added Clay,{' '}
        <a href="https://go.clay.earth/zapier-docs" target="_blank">
          follow these instructions
        </a>{' '}
        to get started.
      </div>
    </Section>
  );
}
